<template>
  <ModalDialog :show="show" @close="close" target-class="modal__card--mini">
    <div class="flux-regalo">
      <div class="flux-regalo__title">{{ $t("guest.example.title") }}</div>
      <div class="flux-regalo__msg">{{ $t("guest.example.subtitle") }}</div>
    </div>
  </ModalDialog>
</template>

<script>
import { mapGetters } from "vuex";
import ModalDialog from "./ModalDialog.vue";

// Global, single-instance message shown whenever a buy/reserve/mark-as-bought
// control is tapped/clicked on a locked (demo) list - see the DemoLockable
// mixin. Centered like every other modal in the app, so it can never end up
// off-screen the way a positioned tooltip can on small viewports.
export default {
  name: "DemoLockMessage",
  components: {
    ModalDialog,
  },
  computed: {
    ...mapGetters({
      show: "demoLockMessage",
    }),
  },
  methods: {
    close() {
      this.$store.commit("setDemoLockMessage", false);
    },
  },
};
</script>
